var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416016 15.9166V14.0416C0.416016 14.0416 4.99935 11.75 8.12435 10.9166V6.50913C8.12435 5.85079 8.31602 5.20496 8.71352 4.68079C9.01685 4.28079 9.40352 3.80413 9.79102 3.41663H10.2077C10.5952 3.80413 10.9827 4.28079 11.2852 4.68079C11.6835 5.20496 11.8743 5.85079 11.8743 6.50913V10.9166C14.9993 11.75 19.5827 14.0416 19.5827 14.0416V15.9166C19.5827 15.9166 14.9993 15.0833 11.8743 15.0833C11.8743 15.0833 11.4577 16.9833 11.4577 20.5C11.4577 20.5 12.4993 21.125 13.3327 21.9583V22.375C13.3327 22.375 11.4577 22.1666 9.99935 22.1666C8.54102 22.1666 6.66602 22.375 6.66602 22.375V21.9583C7.49935 21.125 8.54102 20.5 8.54102 20.5C8.54102 16.9833 8.12435 15.0833 8.12435 15.0833C4.99935 15.0833 0.416016 15.9166 0.416016 15.9166Z",
    stroke: "#4A4A4A",
    strokeWidth: 0.833333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5L16.6471 10L23 4",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateFlight);
export default __webpack_public_path__ + "static/media/activate-flight.9d4a802e3d36399963861ef01b46282d.svg";
export { ForwardRef as ReactComponent };